import React from 'react';
import { Form, InputNumber } from 'antd';
import { formatMoney } from '@app/utils/utils';

interface Props {
  rowClassName: string;
  labelClassName: string;
  onCalcTotal: () => void;
}

/**
 * Ô sửa số điểm dùng + dòng "Trừ điểm" trên bill + các field ẩn của đổi điểm. Chỉ points_used được backend
 * nhận (Order::PointRedemption tự tính tiền); points_requested / point_value / points_available giữ lựa chọn
 * của nhân viên để tính lại khi thêm bớt hàng và để đơn tạm khôi phục sau F5.
 */
const PointsDiscountRow: React.FC<Props> = ({ rowClassName, labelClassName, onCalcTotal }) => {
  const form = Form.useFormInstance();
  const pointsUsed = Number(Form.useWatch('points_used', form)) || 0;
  const pointsDiscount = Number(Form.useWatch('points_discount_amount', form)) || 0;
  const requested = Number(Form.useWatch('points_requested', form)) || 0;
  const available = Number(Form.useWatch('points_available', form)) || 0;
  const pointValue = Number(Form.useWatch('point_value', form)) || 0;

  const changePoints = (value: number | null) => {
    form.setFieldsValue({ points_requested: value ?? 0 });
    onCalcTotal();
  };

  return (
    <>
      {pointValue > 0 && (available > 0 || requested > 0) && (
        <div className={rowClassName}>
          <span className={labelClassName}>
            Dùng điểm (có {available} điểm = {formatMoney(Math.round(available * pointValue))})
          </span>
          <InputNumber<number>
            size="small"
            min={0}
            max={available > 0 ? available : undefined}
            precision={0}
            value={requested}
            onChange={changePoints}
            aria-label="Số điểm dùng"
          />
        </div>
      )}
      {requested > 0 && (
        <div className={rowClassName}>
          <span className={labelClassName}>
            Trừ điểm tích luỹ ({pointsUsed}
            {pointsUsed < requested ? `/${requested}` : ''} điểm)
          </span>
          <strong className="tw-text-[13px] tw-text-error">-{formatMoney(pointsDiscount)}</strong>
        </div>
      )}
      {['points_used', 'points_discount_amount', 'points_requested', 'point_value', 'points_available'].map((name) => (
        <Form.Item key={name} name={name} hidden>
          <InputNumber />
        </Form.Item>
      ))}
    </>
  );
};

export default PointsDiscountRow;
